import { takeLatest, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_BOOKING_DETAILS,
  GET_UTILITY_BOOKING_DETAILS_SUCCESS,
  GET_UTILITY_BOOKING_DETAILS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityBookingDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/booking-details`,
      method: 'GET',
      headers: filteredHeaders,
      params: {
        booking_id: payload.bookingId,
        project_code: payload.projectCode,
      },
    });

    const apiMessage = response?.data?.message;
    const isError = response?.data?.status === 'error' || !response?.data?.data;

    if (response.status === 200 && !isError) {
      yield put({
        type: GET_UTILITY_BOOKING_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(apiMessage || "Booking Not Found");
      yield put({
        type: GET_UTILITY_BOOKING_DETAILS_ERROR,
        payload: apiMessage || 'Something went wrong',
      });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_BOOKING_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetUtilityBookingDetails() {
  yield takeLatest(GET_UTILITY_BOOKING_DETAILS, getUtilityBookingDetails);
}

function* getUtilityBookingDetailsSaga() {
  yield all([fork(watchGetUtilityBookingDetails)]);
}

export default getUtilityBookingDetailsSaga;
